import * as React from 'react';
import { useEffect } from 'react';

import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box } from "@mui/material";

import { useAuth0 } from '@auth0/auth0-react';

import { CheckinList } from '../Checkins/CheckinList';
import { Header } from '../Header/Header';
import { EnterCheckin } from '../Checkins/EnterCheckin';
import { SideBar } from './SideBar';
import { JobApp } from '../JobApp/JobApp';


const Home = () => {
    const { user, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    const [loading, setLoading] = React.useState(true);
    const [checkins, setCheckins] = React.useState([]);

    useEffect(() => {
        fetchCheckins();
    }, []);

    function fetchCheckins() {
        setLoading(true)

        const headers = new Headers();
        headers.append("x-functions-key", "GG8S0UvrR4aSl9p4MdbA4qs9Dr2TbyOTiCNY_aZvp6cIAzFuGXFPWQ==");

        const requestOptions = {
            method: "GET",
            headers: headers,
            redirect: "follow"
        };
        // const baseUri = "http://localhost:7071";
        const baseUri = "https://api-ember.azurewebsites.net"

        const url = baseUri + "/api/checkins?user_id=" + user.sub + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                setCheckins(result.list);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    if (isLoading) {
        return <div>Loading...</div>
    }

    if (!isAuthenticated) {
        loginWithRedirect();
        return
    }

    function refreshCheckins() {
        fetchCheckins();
    }

    return (

        <div id="home-grid" style={{

            display: 'flex',
            flexDirection: 'column',
            height: '100vh'
        }}
        >
            <div id="side-bar"
                style={{
                    position: 'fixed',
                }}
            >
                <SideBar />
            </div>
            <div
                style={{
                    flex: 1,
                    overflowY: 'auto'
                }}
            >
                <Grid2

                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid2
                        item
                        xs={10} sm={9} md={7} lg={7} xl={6}
                    >
                        <Box mb={5} />
                        <Header user={user} checkins={checkins} loadingCheckins={loading} />
                        <CheckinList checkins={checkins} loadingCheckins={loading} />
                        <Box mb={5} />
                    </Grid2>
                </Grid2>
            </div>
            <Grid2

                container
                justifyContent="center"
                alignItems="center"
            >
                <Grid2
                    item
                    xs={10} sm={9} md={7} lg={7} xl={6}
                >
                    <EnterCheckin user={user} refreshCheckins={refreshCheckins} />
                </Grid2>
            </Grid2>
        </div>
        // <Grid2
        //     id="home-grid"
        //     container
        //     spacing={2}
        //     // justifyContent="center"
        //     justifyContent="space-between"
        //     alignItems="flex-start"
        // >
        //     <Grid2
        //         item
        //         // style={{ backgroundColor: '#f0f0f0' }}
        //         xs={0} sm={2} md={2} lg={2} xl={2}
        //     >
        //         <div id="side-bar">
        //             <SideBar />
        //         </div>
        //     </Grid2>
        //     <Grid2
        //         item
        //         xs={10} sm={9} md={7} lg={7} xl={6}
        //     >
        //         <div id="main-content"
        //             style={{
        //                 paddingTop: '30px',
        //                 overflowY: 'auto',
        //             }}>


        //             <div
        //                 style= {{
        //                     flex: 1,
        //                     // width: 1,               // == '100%'
        //                     minWidth: 0,            // allow content to shrink instead of overflow
        //                     overflowY: 'auto',
        //                     pr: 1,  
        //                 }}
        //             >
        //                 <Header user={user} checkins={checkins} loadingCheckins={loading} />
        //                 <CheckinList checkins={checkins} loadingCheckins={loading} />
        //             </div>
        //             <EnterCheckin user={user} refreshCheckins={refreshCheckins} />
        //         </div>
        //     </Grid2>
        //     <Grid2 item xs={2}></Grid2>
        // </Grid2>
    );
}

export default Home;